import styled from 'styled-components';

export const ArrowNextButton = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 44px;
	height: 44px;
	border-radius: 50%;
	box-shadow: 0 1px 11px 0 rgba(0, 0, 0, 0.2);
	position: absolute;
	top: -53px;
	right: 0;
	cursor: pointer;

	&.bottomAlign{
		top: 60%;
		transform: translate(0, 185px);
	}

	&.wallet{
		top: -20px;
		width: 36px;
		height: 36px;
		left: 87%;
	}

	&::before {
		border: solid #ff664b;
		border-width: 0 2px 2px 0;
		display: inline-block;
		padding: 4px;
		transform: rotate(-45deg);
		position: relative;
		right: 0;
		top: 0px;
		content: "";
	}
	&.demoArr {
		&::before {
			border: solid #9b9b9b;
			border-width: 0 2px 2px 0;
		}
	}
`;

export const ArrowPrevButton = styled(ArrowNextButton)`
	left: 91%;
	&.leftCenetered {
		left: 80%;
	}
	&.wallet{
		left: 82%;
	}
	&::before {
		transform: rotate(135deg);
	}
	&.demoArr {
		&::before {
			border: solid #9b9b9b;
			border-width: 0 2px 2px 0;
		}
	}
`;
